export const HTML_EDITOR_QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    ['link', 'clean']
  ]
};

export const HTML_EDITOR_QUILL_MODULES_HIDE = {
  toolbar: false
};

export const HTML_EDITOR_QUILL_FORMATS = [
  'header',
  'font',
  'size',
  'background',
  'color',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'align',
  'list',
  'indent',
  'link',
  'image',
  'width',
  'variable-chip'
];

export const HTML_FIRST_PART_PAGE_CODE =
  '<!DOCTYPE html>\n' +
  '<html>\n' +
  '<head>\n' +
  '    <style>\n' +
  '        .ql-align-center   { text-align: center; }\n' +
  '        .ql-align-right    { text-align: right; }\n' +
  '        .ql-align-left     { text-align: left; }\n' +
  '        .ql-align-justify  { text-align: justify; }\n' +
  '        .ql-size-huge      { font-size: 2.5em; }\n' +
  '        .ql-size-large     { font-size: 1.5em; }\n' +
  '        .ql-size-small     { font-size: 0.75em; }\n' +
  '        .ql-font-serif     { font-family: Georgia, Times New Roman, serif; }\n' +
  '        .ql-font-monospace { font-family: Monaco, Courier New, monospace; }\n' +
  '        strong, b { font-weight: bold !important; }\n' +
  '        ul, ol { margin: 0 0 1em 1.5em !important; padding: 0 !important; }\n' +
  '        ul { list-style-type: disc !important; list-style-position: inside !important; }\n' +
  '        ol { list-style-type: decimal !important; list-style-position: inside !important; }\n' +
  '        li { display: list-item !important; margin: 0.2em 0 !important; }\n' +
  '        blockquote { border-left: 4px solid #ccc; margin: 0.5em 0; padding-left: 1em; color: #555; }\n' +
  '        .ql-email-content img { max-width: 100%; height: auto; }\n' +
  '    </style>\n' +
  '</head>\n' +
  '<body><div class="ql-email-content">';

export const HTML_LAST_PART_PAGE_CODE = '</div></body>\n' + '</html>';
